import {
  getCorpUser,
  getProjectDetail,
  getPlanById,
  getProjectPagination,
  getProjectMember,
  getTasksStatus,
  getTasksTypes,
  getTaskWorkTypes,
  getTaskGroup,
  getChecklistTemplates,
  getTaskTemplates,
  getReportType,
  GetUserContactCorps
} from '@/api/config'
import $config from '../static/config'

const actions = {
  getCorpUser (context) {
    let condition = {
      PageIndex: 1,
      PageSize: 1000,
      OrderBy: 'LastUpdatedOn desc'
    }
    getCorpUser(condition).then(res => {
      res.Data.forEach(ele => {
        ele.AvatarUrl = $config.baseURL + '/api/Attachments/' + ele.DocFileId + '?isAvatar=true'
      })
      context.commit('getCorpUser', res.Data)
    })
  },
  getProject (context, obj) {
    return new Promise(async (resolve, reject) => {
      if (context.state.jobsiteID === obj.jobsiteId) {
        if (obj.planId) {
          if (context.state.plan.PlanId !== obj.planId) {
            let plan = await getPlanById(obj.planId)
            context.commit('setPlan', plan)
          }
        }
        resolve()
        return
      }
      context.commit('getJobSite', obj.jobsiteId)
      getProjectDetail(obj.jobsiteId).then(async res => {
        let addressObj = {
          Street: res.Street,
          City: res.City,
          State: res.State,
          Country: res.Country,
          ZipCode: res.ZipCode
        }
        context.commit('getCreator', res.CreatorId)
        context.commit('getJobsiteName', res.Name)
        context.commit('getJobsiteLocation', $config.Address(addressObj))
        if (context.state.projectList.findIndex(q => q.JobsiteId === obj.jobsiteId) < 0) {
          let condition = {
            Name: res.Name,
            Status: null,
            UserId: null,
            CreatedOnFrom: null,
            CreatedOnTo: null,
            isClosed: false,
            PageIndex: 1,
            AllowLoadDashboard: true,
            PageSize: 10,
            OnlyMember: true,
            OrderBy: 'LastUpdatedOn desc'
          }
          getProjectPagination(condition).then(res => {
            context.commit('projectList', res.Data)
          })
        }
        if (obj.planId) {
          if (context.state.plan.PlanId !== obj.planId) {
            let plan = await getPlanById(obj.planId)
            context.commit('setPlan', plan)
          }
        }
        resolve()
      }).catch(err => {
        context.commit('clearJobSite')
        reject(err)
      })
    })
  },
  getProjectMember (context, id) {
    let condition = {
      JobsiteId: context.state.jobsiteID,
      PageIndex: 1,
      PageSize: 1000
    }
    if (id) {
      condition.JobsiteId = id
    } else {
      condition.JobsiteId = context.state.jobsiteID
    }
    getProjectMember(condition).then(res => {
      res.Data.forEach(ele => {
        ele.AvatarUrl = $config.baseURL + '/api/Attachments/' + ele.DocFileId + '?isAvatar=true'
      })
      context.commit('getProjectMember', res.Data)
      return res.Data
    })
  },
  getTasksStatus (context) {
    getTasksStatus().then(res => {
      context.commit('getTasksStatus', res)
    })
  },
  getTasksTypes (context) {
    let data = {
      getInvisible: false
    }
    getTasksTypes(data).then(res => {
      context.commit('getTasksTypes', res)
    })
  },
  getTaskChecklistTemplates (context) {
    let condition = {
      PageIndex: 1,
      PageSize: 1000,
      OrderBy: 'CreatedOn desc'
    }
    getChecklistTemplates(condition).then(res => {
      context.commit('getTaskChecklistTemplates', res.Data)
    })
  },
  getTaskTemplates (context) {
    let condition = {
      PageIndex: 1,
      PageSize: 1000,
      NeedItems: true,
      OrderBy: 'CreatedOn desc'
    }
    getTaskTemplates(condition).then(res => {
      context.commit('getTaskTemplates', res.Data)
    })
  },
  getTaskWorkTypes (context) {
    getTaskWorkTypes().then(res => {
      context.commit('getTaskWorkTypes', res)
    })
  },
  getTaskGroup (context, id) {
    return new Promise((resolve, reject) => {
      let condition = {
        JobsiteId: context.state.jobsiteID,
        PageIndex: 1,
        PageSize: 1000,
        OrderBy: 'LastUpdatedOn desc'
      }
      if (id) {
        condition.JobsiteId = id
      } else {
        condition.JobsiteId = context.state.jobsiteID
      }
      getTaskGroup(condition).then(res => {
        context.commit('getTaskGroup', res.Data)
        resolve()
      })
    })
  },
  getReportType (context) {
    let data = {
      userFilter: true
    }
    getReportType(data).then(res => {
      context.commit('getReportType', res)
    })
  },
  getUserContactCorps (context) {
    GetUserContactCorps(context.state.userInfo.UserId).then(res => {
      context.commit('getUserContactCorps', res)
    })
  }
}
export default actions
